import { render, staticRenderFns } from "./OJResultModal.vue?vue&type=template&id=0e71bb38&scoped=true&"
import script from "./OJResultModal.vue?vue&type=script&lang=js&"
export * from "./OJResultModal.vue?vue&type=script&lang=js&"
import style0 from "./OJResultModal.vue?vue&type=style&index=0&id=0e71bb38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e71bb38",
  null
  
)

export default component.exports